var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoPast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.00012207H7C6.20435 0.00012207 5.44129 0.316193 4.87868 0.878802C4.31607 1.44141 4 2.20447 4 3.00012V4.00012H3C2.20435 4.00012 1.44129 4.31619 0.87868 4.8788C0.31607 5.44141 0 6.20447 0 7.00012L0 17.0001C0 17.7958 0.31607 18.5588 0.87868 19.1214C1.44129 19.6841 2.20435 20.0001 3 20.0001H13C13.7956 20.0001 14.5587 19.6841 15.1213 19.1214C15.6839 18.5588 16 17.7958 16 17.0001V16.0001H17C17.7956 16.0001 18.5587 15.6841 19.1213 15.1214C19.6839 14.5588 20 13.7958 20 13.0001V3.00012C20 2.20447 19.6839 1.44141 19.1213 0.878802C18.5587 0.316193 17.7956 0.00012207 17 0.00012207V0.00012207ZM14 17.0001C14 17.2653 13.8946 17.5197 13.7071 17.7072C13.5196 17.8948 13.2652 18.0001 13 18.0001H3C2.73478 18.0001 2.48043 17.8948 2.29289 17.7072C2.10536 17.5197 2 17.2653 2 17.0001V7.00012C2 6.73491 2.10536 6.48055 2.29289 6.29302C2.48043 6.10548 2.73478 6.00012 3 6.00012H4V13.0001C4 13.7958 4.31607 14.5588 4.87868 15.1214C5.44129 15.6841 6.20435 16.0001 7 16.0001H14V17.0001ZM18 13.0001C18 13.2653 17.8946 13.5197 17.7071 13.7072C17.5196 13.8948 17.2652 14.0001 17 14.0001H7C6.73478 14.0001 6.48043 13.8948 6.29289 13.7072C6.10536 13.5197 6 13.2653 6 13.0001V3.00012C6 2.73491 6.10536 2.48055 6.29289 2.29302C6.48043 2.10548 6.73478 2.00012 7 2.00012H17C17.2652 2.00012 17.5196 2.10548 17.7071 2.29302C17.8946 2.48055 18 2.73491 18 3.00012V13.0001Z",
    fill: "#004685"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5L11 10.5L15.5 5.5",
    stroke: "#004685",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPast);
export default __webpack_public_path__ + "static/media/picto_past.5837221ef25e29bfa32caf3ab352f603.svg";
export { ForwardRef as ReactComponent };